export enum ErrorActionType {
  Back = "back",
  Dashboard = "dashboard",
  Homepage = "homepage",
  BackToLogin = "backToLogin",
  UpdateApp = "updateApp"
}
